/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DataKeysService {

    /**
     * Export data keys
     * Returns the account's own data keys with their settings, and the global keys its questions use. Compatible with POST /internal_api/data_keys/import.
     * @param xAccessToken
     * @returns any OK
     * @throws ApiError
     */
    public static getInternalApiDataKeysExport(
        xAccessToken: string,
    ): CancelablePromise<{
        data_keys?: Array<{
            key?: string;
            key_type?: string | null;
            title?: string | null;
            restricted?: boolean;
            storage?: string | null;
            approval_value_type?: string | null;
            concept_id?: string | null;
            concept_option_mappings?: any;
        }>;
        global_keys?: Array<any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/data_keys/export',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }

    /**
     * Import data keys
     * Creates each data key the account lacks, with its settings. A key the account or the global catalog already holds is kept and never overwritten. Source globals are reported against what this cluster has (`present`, `missing` when the standard catalog defines the key, `skipped` when it does not); this endpoint never creates or converts a global, since that write reaches every tenant on the cluster.
     * @param xAccessToken
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postInternalApiDataKeysImport(
        xAccessToken: string,
        requestBody: any,
    ): CancelablePromise<{
        created?: Array<string>;
        kept?: Array<string>;
        failed?: Array<any>;
        global_keys?: {
            present?: Array<string>;
            missing?: Array<string>;
            skipped?: Array<any>;
        };
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal_api/data_keys/import',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Register applicant data keys
     * Find-or-create applicant data keys for the account and mark them in use, so they are immediately selectable in consumers of the data-key catalog (e.g. automation trigger dropdowns). Idempotent per key; invalid keys are skipped and reported, not rejected wholesale.
     * @param requestBody
     * @param xAccessToken API token (alternative to the WX JWT bearer token)
     * @returns any keys registered
     * @throws ApiError
     */
    public static postInternalApiWxDataKeysRegister(
        requestBody: {
            /**
             * Data keys to register (lowercase alphanumeric + underscores)
             */
            keys: Array<string>;
        },
        xAccessToken?: string,
    ): CancelablePromise<{
        success?: boolean;
        registered?: Array<string>;
        skipped?: Array<{
            key?: string;
            reason?: string;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal_api/wx/data_keys/register',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `unauthorized`,
                422: `invalid payload`,
            },
        });
    }

}